var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93317 4.66667H20.0665C22.0267 4.66667 23.0068 4.66667 23.7555 5.04814C24.414 5.3837 24.9495 5.91913 25.285 6.5777C25.499 6.99762 25.5929 7.49033 25.6342 8.18793M20.0665 23.3333H7.93317C5.97299 23.3333 4.99289 23.3333 4.2442 22.9519C3.58564 22.6163 3.0502 22.0809 2.71465 21.4223C2.33317 20.6736 2.33317 19.6935 2.33317 17.7333V10.2667C2.33317 8.30648 2.33317 7.32639 2.71465 6.5777M25.285 21.4223C25.6665 20.6736 25.6665 19.6935 25.6665 17.7333V10.2667C25.6665 9.40589 25.6665 8.73411 25.6342 8.18793M25.6342 8.18793L17.3074 13.668M25.6342 8.18793L25.6665 8.16667M1.1665 3.5L23.3332 25.6667",
    stroke: "#101825",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOff);
export default __webpack_public_path__ + "static/media/mail-off.aa81fa7a4b2f0542049ef29baf896e86.svg";
export { ForwardRef as ReactComponent };